import { LayoutProps } from 'components/atoms/Layout/interfaces';
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces';
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces';
import { FormVehicleKeys } from './types';

interface Schema {
    id: FormVehicleKeys
}

interface AutocompleteSchemaProps {
    id: FormVehicleKeys;
    label: string;
    required?: boolean;
}

interface FormVehicleInterface {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    autocomplete?: AutocompleteSchemaProps & Schema;
    layout: LayoutProps
}

type RequiredFieldsByDetran = {
    [key: string]: string[]
}

const fieldRequiredByDetran = (ufContract: string, field: string): boolean => {
    const UF_CONTRACT = ufContract

    const requiredFieldsByDetran: RequiredFieldsByDetran = {
        RJ: ['marca', 'cor']
    }

    if (!requiredFieldsByDetran[ufContract]) return false
    return requiredFieldsByDetran[UF_CONTRACT].includes(field)
}

export const FormVehicleValue = (
    ufContract: string
): FormVehicleInterface[] => {
    return [
        {
            input: {
                id: 'chassi',
                label: 'Chassi',
                required: true,
                onKeyUp: () => ({})
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 5 }
            }
        },
        {
            input: {
                id: 'renavam',
                label: 'Renavam',
                maxLength: 11
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 5 }
            }
        },
        {
            select: {
                id: 'ufGravame',
                label: 'UF gravame',
                required: true,
                optionsType: 'uf',
                isDisable: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 2 }
            }
        },
        {
            input: {
                id: 'numeroGravame',
                label: 'Nº do Gravame/Restrição',
                type: 'number',
                inputMode: 'numeric',
                onKeyDown: (e: any) =>
                    ['e', 'E', '+', '-', '.', ',', '='].includes(e.key) &&
                    e.preventDefault(),
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            select: {
                id: 'uf',
                label: 'UF placa',
                optionsType: 'uf'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 2 }
            }
        },
        {
            input: {
                id: 'placa',
                label: 'Placa:',
                placeholder: 'Digite',
                maskReplace: 'placa'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 2 }
            }
        },
        {
            input: {
                id: 'anoFabricacao',
                label: 'Ano fabricação',
                type: 'number',
                inputMode: 'numeric',
                placeholder: '0000',
                required: true,
                onKeyDown: (e: any) =>
                    ['e', 'E', '+', '-', '.', ',', '='].includes(e.key) &&
                    e.preventDefault()
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 2 }
            }
        },
        {
            input: {
                id: 'anoModelo',
                label: 'Ano modelo',
                type: 'number',
                inputMode: 'numeric',
                placeholder: '0000',
                required: true,
                onKeyDown: (e: any) =>
                    ['e', 'E', '+', '-', '.', ',', '='].includes(e.key) &&
                    e.preventDefault()
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'identificacaoRemarcacao',
                label: 'Remarcado?',
                required: true,
                options: [
                    {
                        text: 'SIM',
                        value: 1
                    },
                    {
                        text: 'NÃO',
                        value: 0
                    }
                ]
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'especie',
                label: 'Especie do Veiculo',
                optionsType: 'especieVeiculo',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'cor',
                label: 'Cor',
                type: 'text',
                required: fieldRequiredByDetran(ufContract, 'cor')
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            autocomplete: {
                id: 'marca',
                label: 'Marca/Modelo',
                required: fieldRequiredByDetran(ufContract, 'marca')
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'indicativoVeiculoNovo',
                label: 'Indicativo Veículo Novo',
                options: [
                    {
                        text: 'Não informado',
                        value: 'not_informed'
                    },
                    {
                        text: 'Sim',
                        value: true
                    },
                    {
                        text: 'Não',
                        value: false
                    }
                ],
                defaultValue: 'not_informed',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'numeroMotor',
                label: 'N° do Motor',
                required: false
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        }
    ]
}
